import Dictionary from "./Dictionary";
import logo from "./logo.PNG";
import "./App.css";

export default function App() {
  return (
    <div className="App">
      <div className="container">
        <header className="App-header">
          <img src={logo} className="App-logo img-fluid" alt="logo" />
        </header>
        <main>
          <Dictionary defaultKeyword="sunset" />
        </main>
        <footer className="App-footer">
          <small>Coded by Alejandra Castillo</small>
        </footer>
      </div>
    </div>
  );
}
